

export const ranklessType: string[] = ['Spell Card', 'Trap Card', 'Link Monster'];

// When a card got multiple types, he got multiple applied CSS. In some peculiar situations, we want it to have one and only one type.
export const oneTypeOnlyCardTypes: string[] = ['effect-type', 'invocation-materials'];

export const removedFromSelectionCardTypes: string[] = ['Skill Card'];

export const removedFromSelectionCards: string[] = [];